<template>
  <div
    class="hero is-fullheight is-flex is-align-items-center is-justify-content-center"
  >
    <div class="hero-body">
      <div v-if="!confirmed && !success">
        <b-loading v-model="loading" />
        Wir überprüfen gerade Ihren Token.
      </div>

      <div v-if="confirmed && success" class="box">
        <h3 class="is-size-3 has-text-weight-bold" style="color: #d52817">
          Vielen Dank, dass Sie Ihre E-Mail-Adresse bestätigt haben!
        </h3>

        <h3 class="is-size-3 has-text-weight-bold" style="color: #d52817">
          Thank You for Confirming Your Email Address!
        </h3>

        <p class="has-text-weight-bold">Friends of St. Anton Community</p>
      </div>
      <div v-else-if="confirmed && !success" class="box">
        <h3 class="is-size-3 has-text-weight-bold" style="color: #d52817">
          Leider ist ein Fehler aufgetreten!
        </h3>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data: () => ({
    loading: false,
    confirmed: false,
    success: false,
    apiURL:
      process.env.NODE_ENV === "production"
        ? "https://www.friendsofstanton.com/community-card/data.php"
        : "http://localhost/arlberg/data.php",
  }),

  async created() {
    if (this.$route.query.lang === "en") {
      this.$i18n.locale = "en";
    } else {
      this.$i18n.locale = "de";
    }
    document.documentElement.lang = this.$i18n.locale;

    this.loading = true;
    const confirmResult = await axios.get(
      `${this.apiURL}?confirm=${this.$route.query.token}`
    );

    if (confirmResult.data) {
      this.confirmed = true;

      if (confirmResult.data.success === true) {
        this.success = true;
      }
    }

    this.loading = false;
  },
};
</script>
